import { render, staticRenderFns } from "./Farm.vue?vue&type=template&id=44a5a25e&"
import script from "./Farm.vue?vue&type=script&lang=ts&"
export * from "./Farm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports